import { performAlgoliaNearbySearch } from 'client/javascript/geo';
import * as storage from 'client/javascript/storage';
import { get } from 'shared/util/helpers';

export default async function getClosestMarket(numberOfResults = 1) {
  try {
    const search = await performAlgoliaNearbySearch(numberOfResults);
    return get(search, 'results[0].hits[0]', {});
  } catch (error) {
    console.log('Some error happened getting the closest market', error); // eslint-disable-line no-console
  }
}

export const getLocationId = async () => {
  const locationIdFromLocalStorage = storage.getLocationId();
  if (locationIdFromLocalStorage) {
    return locationIdFromLocalStorage;
  }
  const closestMarket = (await getClosestMarket()) || {};
  return closestMarket.id;
};
